module.exports = __webpack_public_path__ + "img/small1.9b4b620c.jpg";